import React                   from 'react'
import i18n from '../../../i18n';
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ButtonLoading from "../../common/ButtonLoading"

export default (props) => {
  const { isOpen, toggle, className, name , isProcessing, cancel, submit } = props;

  return (
    <Modal isOpen={isOpen} className={className} centered={true}>
      <ModalHeader toggle={toggle}>{i18n.t('application.modal_delete_header')}</ModalHeader>
      <ModalBody>
        <div className="form-group">
          {i18n.t('application.modal_delete_body_name', {name: name})}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={cancel} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
        <ButtonLoading text={i18n.t('common.delete')} className="btn mfc-btn-red medium" isProcessing={isProcessing} onClick={submit} />
      </ModalFooter>
    </Modal>
  )
}
